module.exports = __webpack_public_path__ + "static/media/README.4f077b0c.md";